<template>
  <v-card flat class="py-5">
    <v-card-title
      primary-title
      class="pa-0 font-weight-bold mb-12 justify-center"
    >
      {{ title }}
    </v-card-title>

    <transition>
      <v-card-subtitle
        class="info--text custom-info-box"
        v-if="subtitle && !sendingEmail"
      >
        <v-alert border="left" close-text="Close" text type="info" dense>
          {{ subtitle }}
        </v-alert>
      </v-card-subtitle>
    </transition>

    <v-card-text>
      <span v-if="error" class="error--text">
        Wrong or no confirmation code provided!
      </span>
      <ValidationObserver ref="validator">
        <v-form @submit.prevent="">
          <ValidationProvider
            name="confirmation_code"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              :readonly="Boolean($route.query.code)"
              :disabled="Boolean($route.query.code)"
              name="code"
              :error-messages="errors"
              v-model="code"
              label="Confirmation Code"
              required
            />
          </ValidationProvider>
          <ValidationProvider
            v-if="!hasPassword"
            name="password"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              name="password"
              type="password"
              :error-messages="errors"
              v-model="password"
              label="Password"
              required
            />
          </ValidationProvider>
          <ValidationProvider
            v-if="!hasPassword"
            name="password_confirmation"
            :rules="password ? `required|confirm:@password` : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              name="password_confirmation"
              type="password"
              :error-messages="errors"
              v-model="password_confirmation"
              label="Password Confirmation"
              required
            />
          </ValidationProvider>
          <v-btn
            type="submit"
            depressed
            block
            x-large
            color="primary"
            :loading="submitting"
            :disabled="submitting"
            class="font-weight-bold my-5"
            @click.prevent="confirm()"
          >
            Confirm
          </v-btn>
          <v-btn
            :disabled="submitting"
            text
            block
            large
            color="primary"
            class="font-weight-bold title"
            :to="{ name: 'login' }"
          >
            Go to Login
          </v-btn>

          <transition>
            <v-alert
              v-if="subtitle && email && !sendingEmail"
              border="left"
              close-text="Close"
              type="warning lighten-1"
              class="black--text custom-alert-box"
              dense
            >
              Did not get the email?
              <v-btn color="primary" @click.prevent.stop="resend()">
                Send Again
              </v-btn>
            </v-alert>
          </transition>
        </v-form>
      </ValidationObserver>
    </v-card-text>
  </v-card>
</template>

<script>
import { postPromise } from '@services/Promise';

export default {
  name: 'Confirm',
  metaInfo: {
    titleTemplate: '%s - Confirmation',
  },
  async beforeRouteEnter(to, from, next) {
    if (from.name === 'register' && window.$registered) {
      next();
      return;
    }
    let code = to.query.code;
    if (!((from.name === 'register' && window.$registered) || code)) {
      next('/');
    }
    let hasPassword = to.query.hasOwnProperty('set_password')
      ? !Boolean(parseInt(to.query.set_password))
      : true;
    if (!code) {
      next((vm) => {
        vm.error = true;
        vm.hasPassword = true;
      });
      return;
    }
    if (!hasPassword) {
      next((vm) => {
        vm.code = code;
        vm.hasPassword = hasPassword;
      });
      return;
    }
    let response = await postPromise('/users/confirmation', {
      confirmation_code: code,
    }).catch((error) => {
      $showError(error.response.data.message, 'email-confirmation');
    });
    if (response) {
      $showSuccess(
        'Your email has been confirmed',
        'Congratulation!',
        'email-confirmation'
      );
      next('/');
    }
    next((vm) => (vm.hasPassword = hasPassword));
  },
  data() {
    return {
      sendingEmail: false,
      email: this.$route.query.email,
      title: 'Verify your email!',
      hasPassword: true,
      error: false,
      subtitle: '',
      submitting: false,
      code: '',
      password: '',
      password_confirmation: '',
    };
  },
  methods: {
    async confirm() {
      this.submitting = true;
      if (await this.$refs.validator.validate()) {
        let response = await postPromise('/users/confirmation', {
          confirmation_code: this.code,
          password: this.password,
          password_confirmation: this.password_confirmation,
        }).catch((error) => {
          $showError(error.response.data.message, 'email-confirmation');
          return false;
        });
        if (response) {
          $showSuccess(
            'Your email has been confirmed',
            'Congratulation!',
            'email-confirmation'
          );
          await this.$router.push({
            name: 'login',
          });
        }
      }
      this.submitting = false;
    },
    async resend(email = this.email) {
      this.sendingEmail = true;
      if (email) {
        let response = await postPromise('/users/confirmation/send', {
          email: email,
        }).catch((error) => {
          $showError(error.response.data.message, 'email-confirmation');
          return false;
        });
        this.sendingEmail = false;
        if (response) {
        }
      }
    },
  },
  mounted() {
    if (window.$registered) {
      delete window.$registered;
      this.subtitle = 'Please check your email for confirmation code!';
    }
  },
};
</script>

<style scoped></style>
